import * as yup from "yup";
import fieldsSchema from "../fieldsSchema";
export const joinBusinessSchema = yup.object().shape({
  img: fieldsSchema.required_add_img,
  title: fieldsSchema.required_string,
  owner_name: yup.string(),
  phone: fieldsSchema.valid_phone,
  city: yup.object().shape({
    id: fieldsSchema.required_string,
    name: yup.string(),
  }),
  parent_category: yup.object().shape({
    id: fieldsSchema.required_string,
    name: yup.string(),
  }),
  communication_methods: yup
    .object()
    .test("has-key", "ادخل علي الاقل وسيلة تواصل واحدة", (value) => {
      return (
        value &&
        Object.keys(value).length > 0 &&
        Object.values(value).every(
          (v) => typeof v === "string" && v.trim() !== ""
        )
      );
    }),
  location: yup.object().shape({
    type: yup.string(),
    coordinates: yup.array().of(yup.number()),
  }),
});
